// Module
var code = "<div id=\"V-93C561D6-3D21-4BB7-A99F-C09D7B2998FE\"> <div data-b-component=\"scroll\" data-b-comp-vertical=\"true\"> <div data-b-component=\"list\" class=\"list\" data-b-comp-items=\"{Binding executableParts}\"> </div> </div> </div> ";
// Exports
export default code;